export default __webpack_public_path__ + "19b3e1db9e522b38aef0cd87e6b6a38d.svg";